'use strict'

import angular from 'angular'
import $ from "jquery";
import { saveAs } from 'file-saver'

import buySheetWrapperComponentHtmlUrl from './buySheetWrapper.component.html'

angular.module('buySheet.components').component('buySheetWrapper', {
    templateUrl: buySheetWrapperComponentHtmlUrl,
    bindings: {
        orderId: '<',
        configId: '<',
        mayExportBuySheetToExcel: '<',
        backTo: '<'
    },
    controller($ioAlert, BuySheetService) {
        this.notice = ''

        this.$onChanges = () => {
            this.sectionToShow = 'info'
            this.info = 'Loading Buysheet for configuration #' + this.configId + '...'
            this.showBuySheet()
        }

        this.showBuySheet = () => {
            let vm = this
            BuySheetService.getBuySheet(vm.orderId, vm.configId).then(function (response) {
                vm.buySheetData = response.buy_sheet
                vm.sectionToShow = 'buy-sheet'
            }, function (response) {
                vm.handleError(response)
            })
        }

        this.handleError = (error) => {
            let e = 'Sorry, something went wrong here.'
            if (error && error.data && error.data.message) {
                e += ` ${error.data.message}`;
            } else {
                e += ' Please refresh the page to try again.';
            }

            this.error = e
            this.sectionToShow = 'error'
        }

        this.regenerate = () => {
            this.sectionToShow = 'info'
            this.info = 'Regenerating Buysheet...'

            let vm = this
            BuySheetService.regenerate(vm.buySheetData.id)
                .then(function (response) {
                    vm.buySheetData = response.buy_sheet
                    vm.sectionToShow = 'buy-sheet'
                    $ioAlert.show('', 'Buy sheet was successfully regenerated', 'success')
                })
                .catch(function (response) {
                    vm.handleError(response)
                })
        }

        this.exportToPdf = () => {
            let $clone = $(`#buy-sheet-${this.orderId}`).clone()

            this.sectionToShow = 'info'
            this.info = 'Exporting Buysheet to PDF...'

            $clone.find('#buy-sheet-logo').attr('src', this.buySheetData.logo_url_light)

            let vm = this
            BuySheetService.exportToPdf(vm.buySheetData.id, $clone.html())
                .then(function (data) {
                    let file = new Blob([data], {type: 'application/pdf'})
                    saveAs(file, `Buy sheet #${vm.buySheetData.id}.pdf`)

                    vm.sectionToShow = 'buy-sheet'
                    $ioAlert.show('', 'Buy sheet was successfully exported to PDF', 'success')
                }, function (response) {
                    vm.handleError(response)
                })
        }

        this.exportToXlsx = () => {
            if (!this.mayExportBuySheetToExcel) {
                $ioAlert.show('', 'This instance is not configured to export a buysheet to Excel.', 'error')

                return
            }

            this.sectionToShow = 'info'
            this.info = 'Exporting buy sheet to Excel spreadsheet...'

            let vm = this
            BuySheetService.exportToXlsx(vm.orderId)
                .then(function (response) {
                    let file = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                    saveAs(file, `Buy sheet #${vm.buySheetData.id}.xlsx`)

                    vm.notice = response.headers('meta-notice')
                    $ioAlert.show('', 'Buy sheet was successfully exported to an Excel spreadsheet', 'success')
                })
                .catch(function (response) {
                    vm.handleError(response)
                })
        }
    },
    controllerAs: 'vm'
})